<template>
  <!-- nps detail section -->
  <article class="media" v-if="nps">
    <figure class="media-left is-hidden-mobile">
      <avatar :size="45" :username="authorDisplayName"></avatar>
    </figure>
    <div class="media-content">
      <nav class="level is-mobile">
        <div class="level-left">
          <div class="level-item is-hidden-tablet">
            <avatar :size="30" :username="authorDisplayName"></avatar>
          </div>
          <div
            class="level-item has-text-weight-bold"
            v-text="authorDisplayName"
          ></div>
        </div>
        <div class="level-right">
          <div
            class="level-item has-text-grey is-italic is-hidden-mobile"
          >
            <small
            >{{ nps.created_at | prettyDateTime }}</small
            >
          </div>
        </div>
      </nav>
      <p class="has-text-grey is-italic is-hidden-tablet">
        <small>{{ nps.created_at | prettyDateTime }}</small>
      </p>
      <div class="content">
        {{category(nps.nps_rating)}}: NPS = {{nps.nps_rating}}
      </div>
    </div>
  </article>
</template>

<script>
    /* eslint-disable no-undef */
    import misc from '../mixins/misc.js'
    import Avatar from 'vue-avatar'
    export default {
      name: 'NPSDetails',
      props: ['nps', 'authorDisplayName'],
      components: {
        Avatar
      },
      mixins: [misc]
    }
</script>


// WEBPACK FOOTER //
// src/components/NPSDetails.vue